export default {
  siteTitle: 'AllChinaBuy Spreadsheet — Produkte, Verkäufer & Smarte Kaufguides',
  siteDescription: 'Entdecken Sie AllChinaBuy Spreadsheet-Ressourcen, Produktfunde, Verkäuferguides, QC-Informationen, Versandkosten, Bewertungen und praktische China-Shopping-Guides — alles an einem Ort organisiert.',
  siteKeywords: 'AllChinaBuy, AllChinaBuy spreadsheet, AllChinaBuy Bewertung, China Einkauf, spreadsheet guide',

  navHome: 'Startseite',
  navShoppingGuide: 'Einkaufsguide',
  navCategories: 'Kategorien',
  navSpreadsheet: 'Spreadsheet',
  navProducts: 'Produkte',
  navSellers: 'Verkäufer',
  navGuides: 'Guides',
  navReviews: 'Bewertungen',
  navShipping: 'Versand',
  navQC: 'QC',
  navCoupons: 'Gutscheine',
  navAbout: 'Über uns',
  navContact: 'Kontakt',

  heroH1: 'AllChinaBuy Spreadsheet — Finden Sie Produkte, Verkäufer & Kaufguides',
  heroSub: 'Entdecken Sie AllChinaBuy Spreadsheet-Ressourcen, Produktfunde, Verkäuferguides, QC-Informationen, Versandkosten, Bewertungen und praktische China-Shopping-Guides.',
  ctaExplore: 'AllChinaBuy Spreadsheet Erkunden',
  ctaBuyNow: 'Jetzt Kaufen',
  ctaReview: 'Vollständige Bewertung Lesen',
  ctaVisit: 'Hauptwebsite Besuchen',
  ctaMain: 'AllChinaBuy Spreadsheet',

  categoryTitle: 'Kategorien Durchsuchen',
  categorySubtitle: 'Finden Sie genau das, was Sie brauchen, in unseren kuratierten Spreadsheet-Sammlungen',
  categories: [
    { name: 'Schuhe', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { name: 'Hoodies/Pullover', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
    { name: 'Jacken', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
    { name: 'Hosen/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
    { name: 'Kopfbedeckungen', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
    { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
    { name: 'Unterwäsche', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
    { name: 'Trikots', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
    { name: 'Accessoires', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
    { name: 'Taschen', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
    { name: 'Gürtel', url: 'https://kaspreadsheet.com/category-922-Belts.html' },
    { name: 'Parfums', url: 'https://kaspreadsheet.com/category-923-Perfumes.html' },
    { name: 'Sonstiges', url: 'https://kaspreadsheet.com/category-924-Other+Stuff.html' },
  ],

  articleTitle: 'AllChinaBuy Spreadsheet Guides & Artikel',
  articleSubtitle: 'Vertiefte Ressourcen, die Ihnen helfen, AllChinaBuy wie ein Profi zu nutzen',
  readMore: 'Mehr Lesen',
  article1Title: 'AllChinaBuy Spreadsheet 2026: Kompletter Guide für Smarte Käufer',
  article1Desc: 'Entdecken Sie, wie Sie das AllChinaBuy Spreadsheet nutzen, um die besten Produkte, vertrauenswürdige Verkäufer zu finden und bei Ihren Einkäufen in China zu sparen.',
  article1Meta: 'Aktualisiert August 2026 · 8 Min. Lesezeit',
  backToHome: 'Zurück zur Startseite',
  relatedArticles: 'Verwandte Artikel',
  shareArticle: 'Diesen Guide Teilen',

  footerDisclaimer: 'AllChinaBuySpreadsheet.best ist eine unabhängige Informationsressource und steht nicht in Verbindung mit oder wird von AllChinaBuy unterstützt.',
  footerLinks: 'Schnelllinks',
  footerLegal: 'Rechtliches & Sicherheit',
  footerPrivacy: 'Datenschutzrichtlinie',
  footerTerms: 'Nutzungsbedingungen',
  footerEditorial: 'Redaktionsrichtlinien',
  footerSafety: 'Sicherheitsguide',
  footerCopyright: '© 2026 AllChinaBuySpreadsheet.best. Alle Rechte vorbehalten.',
  footerLanguage: 'Sprache',

  articleIntro: 'Einleitung',
  articleTOC: 'Inhaltsverzeichnis',
  articleConclusion: 'Fazit',
  articleCTA: 'Bereit für intelligenteres Einkaufen?',
  articleCTABtn: 'AllChinaBuy Spreadsheet Erkunden',
  articleInternalLink: 'Kehren Sie zu unserer AllChinaBuy Spreadsheet-Startseite zurück für mehr Ressourcen und Kaufguides.',

  selectCategory: 'Kategorie Auswählen',
  browseAll: 'Alle Kategorien Durchsuchen',

  trustIndependent: 'Unabhängige Ressource',
  trustVerified: 'Überprüfte Informationen',
  trustUpdated: 'Regelmäßig Aktualisiert',
  trustCommunity: 'Community-basiert',
};